var compareItems = function compareItems(item, other) {
  return item.value === other.value && item.group === other.group;
};

export { compareItems };
//# sourceMappingURL=utils.esm.js.map
